import { useEffect } from "react";
import { MdArrowForward } from "react-icons/md";
import { Link } from "react-router-dom";
import iconUrl from "../../svg/aviator.svg";

import "./style.scss";

export default function Home() {
  useEffect(() => {
    const addBtn = document.querySelector(".add-button");
    window.addEventListener("beforeinstallprompt", (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      let deferredPrompt = e;
      // Update UI to notify the user they can add to home screen
      addBtn.style.display = "block";

      addBtn.addEventListener("click", (e) => {
        // hide our user interface that shows our A2HS button
        addBtn.style.display = "none";
        // Show the prompt
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === "accepted") {
            console.log("User accepted the A2HS prompt");
          } else {
            console.log("User dismissed the A2HS prompt");
          }
          deferredPrompt = null;
        });
      });
    });
  }, []);

  return (
    <main className="Home centered">
      <img className="app-icon" src={iconUrl} alt="" height="200px"></img>
      <div className="app-logo-text">PILOT</div>
      <button className="add-button" style={{ "display": "none" }}>Install PWA</button>
      <Link to="/dashboard" className="flex-row flex-align-center flex-gap-sm m-t-lg">
        Proceed to Dashboard
      </Link>
    </main>
  );
}